<template>
    <CRow class="mainContainer bg-white">
        <CRow style="margin: auto">
            <label class="noitem">NO DATA !!!</label>
        </CRow>
    </CRow>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {}
    }
</script>

<style scoped>
    .mainContainer {
        /*border: 1px solid #CCCCCC;*/
        height: 30rem;
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
        border-bottom-left-radius: 16px;
        -webkit-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
        -moz-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
        box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
        margin-bottom: 50%;
    }

    .noitem {
        color: #1a1a1a61;
        font: bold 52px Roboto;
    }
    .noitem:hover {
        position: relative;
        top: -3px;
        left: -3px;
    }

</style>